import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IPolicy } from '../shared/models/policy';

@Injectable({
  providedIn: 'root',
})
export class PoliciesService {
  baseUrl = environment.apiUrl;
  policies: IPolicy[] = [];

  constructor(private http: HttpClient) {}

  getTermsAndConditions() {
    return this.http.get<IPolicy[]>(this.baseUrl + 'termsAndConditions').pipe(
      map((response) => {
        if (!response) {
          console.log('Error Occured while creating.');
          throw new Error('Value Expected');
        }
        return response;
      })
    );
  }

  getTermsAndConditionsById(id: string) {
    const policy = this.policies.find((s) => s.id === id);
    if (policy) {
      return of(policy);
    }

    return this.http.get<IPolicy>(this.baseUrl + 'termsAndConditions/' + id);
  }
}
